<template>
  <v-container fluid class="hero">
    <v-row align="center" justify="center">
      <v-col sm="12" lg="5" md="12">
        <v-card class="elevation-15 pt-4 light_opacity">
          <v-window v-model="step">
            <v-window-item :value="0">
              <v-row>
                <v-col cols="12">
                  <v-card-title class="py-10">
                    <div class="text-center row justify-center">
                      <h1
                        class="font-weight-light"
                        style="color: #3c4858; font-size: 36px"
                      >
                        <img
                          width="80%"
                          src="@/assets/img/rebase_logo_white.png"
                        />
                      </h1>
                    </div>
                  </v-card-title>
                  <v-card-text class="my-5">
                    <v-form
                      ref="registerFrm"
                      @submit.prevent="resetPassword"
                      lazy-validation
                    >
                      <v-text-field
                        v-model="reset.password"
                        label="Password"
                        name="password"
                        outlined
                        prepend-icon="mdi-lock"
                        :rules="passwordRules"
                        type="password"
                        required
                      />
                      <v-text-field
                        v-model="reset.confirm"
                        label="Confirm"
                        name="confirm"
                        outlined
                        prepend-icon="mdi-lock"
                        :rules="confirmPasswordRules"
                        type="password"
                        required
                      />
                      <vue-recaptcha
                        ref="recaptcha"
                        @verify="onVerify"
                        @expired="onExpired"
                        sitekey="6LfCX1EhAAAAAEyP7820FvlNTZdbb-gXGuWAWm_w"
                        class="recaptchax"
                        @click="executeRecaptcha"
                        :loadRecaptchaScript="true"
                      >
                      </vue-recaptcha>
                      <div class="text-center mt-4">
                        <v-btn
                          color="primary"
                          large
                          block
                          class="mx-2"
                          type="submit"
                          :disabled="valid"
                          >Change Password</v-btn
                        >
                      </div>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { gql } from "apollo-boost";
import VueRecaptcha from "vue-recaptcha";
export default {
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      step: 0,
      valid: true,
      reset: {
        password: "",
        confirm: "",
      },
      passwordRules: [
        (v) => !!v || "Please type password.",
        (v) => (v && v.length >= 6) || "minimum 6 characters",
      ],
      confirmPasswordRules: [
        (v) => !!v || "type confirm password",
        (v) =>
          v === this.reset.password ||
          "The password confirmation does not match.",
      ],
    };
  },
  methods: {
    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },
    onVerify: function (response) {
      console.log("Verify: " + response);
      return (this.valid = !this.valid);
    },
    onExpired: function () {
      console.log("Expired");
      return (this.valid = !this.valid);
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    async resetPassword() {
      const self = this;
      try {
        await this.$apollo
          .mutate({
            mutation: gql`
              mutation resetPassword($resetToken: String!, $password: String!) {
                resetPassword(resetToken: $resetToken, password: $password) {
                  id
                  updated
                }
              }
            `,
            variables: {
              resetToken: self.$route.params.id,
              password: self.reset.password,
            },
          })
          .then((response) => {
            self.$swal(
              "Success",
              "Password was successfully reset, please <a href='/'>login</a>",
              "success"
            );
          });
      } catch (e) {
        console.log(`Reset Password Failed: ${JSON.stringify(e)}`);
        self.errorMsg = `${e.message}`;
      }
    },
  },
};
</script>

<style scoped>
.hero {
  background: url("../../assets/img/loginBackground.jpeg");
  background-size: cover;
  height: 100%;
}
</style>
